"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
var utilities_1 = require("./utilities");
var js_cookie_1 = require("js-cookie"), cookies2 = js_cookie_1;
var cookies = js_cookie_1.default || cookies2;
/**
 * 从 cookie 里获取语言码
 *
 * cookie: dd_l=zh-cn
 * cookie: SSO_LANG_V2=ZH-CN 专有钉web环境
 */
function getLanguageFromCookie() {
    return cookies.get(constants_1.COOKIE_NAME) || (cookies.get(constants_1.TAURUS_COOKIE_NAME) || '').toLowerCase() || null;
}
/**
 * 从 window.name 里获取语言码
 *
 * window.name = '{"language":"zh-cn"}'
 */
function getLanguageFromWindowName() {
    var result = null;
    try {
        var nameObj = JSON.parse(window.name);
        if (nameObj && nameObj.language) {
            result = nameObj.language;
        }
    }
    catch (e) {
        result = null;
    }
    return result;
}
/**
 * 从 UserAgent 里获取语言码
 *
 * UserAgent = "Mozilla/5.0 (iPhone; CPU iPhone OS 10_3 like Mac OS X) language/id-CN SomeOtherValue"
 */
function getLanguageFromUserAgent() {
    var result = null;
    var ua = window.navigator.userAgent;
    var matchResult = ua.match(utilities_1.NAVIGATOR_LANGUAGE_REGEX);
    if (matchResult && matchResult.length > 0) {
        result = matchResult[1];
    }
    return result;
}
/**
 * 获取当前环境语言，基于钉钉内部的语言配置方式，优先级分别是
 *
 * userAgent：最高优先级，场景为钉钉客户端内，与客户端保持一致
 * window.name：第二优先级，适用于嵌入的 web 页面，比如 iframe，通过传递 window.name 保持语言一致
 * cookie：纯 web 场景，钉钉在纯 web 环境会配置 cookie 记录用户选择语言。
 */
function languageDetector() {
    var result = null;
    if ((0, utilities_1.hasWindow)()) {
        if (!result) {
            result = getLanguageFromUserAgent();
        }
        if (!result) {
            result = getLanguageFromWindowName();
        }
        if (!result) {
            result = getLanguageFromCookie();
        }
    }
    return result ? (0, utilities_1.getStandardLanguage)(result) : null;
}
exports.default = languageDetector;
//# sourceMappingURL=languageDetector.js.map